import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { ClienteLogin } from '../../../views/login/cliente_login';
import { ConstantService } from "../../../components/common/utils/constant.service";
import { Cliente } from "../../login/cliente_login";
import { DetalleVehiculoEntity, ExtrasEntity } from "../datosGenerales/entities/detalle_vehiculo_entity";
import { DetallesProductosGenerales } from "../datosGenerales/entities/detalle_otros_ramos_entity";
import { VehiculoEntity } from "../datosGenerales/entities/vehiculo_entity";
import { ProductosGeneralesEntity } from "../datosGenerales/entities/productos_generales_entity";
import { AsistenciaMedicaEntity } from "../datosGenerales/entities/asistencia_medica_entity";
import { DetalleViviendaEntity } from "../datosGenerales/entities/detalle_vivienda";
import { ViviendaEntity } from "../datosGenerales/entities/vivienda_entity";
import { SessionStorageService } from "ngx-webstorage";
import { DetalleAsistenciaMedica } from "../datosGenerales/entities/detalle_asistencia_medica";

declare var jQuery: any;

@Injectable()
export class RenovacionService {
    private url = "infoClienteIndividual";
    vehiculoSelect: VehiculoEntity;
    otrosRamos: ProductosGeneralesEntity;
    asistenciaMedica: AsistenciaMedicaEntity;
    vivienda: ViviendaEntity;

    constructor(public authHttp: AuthHttp,public sesionStorageService: SessionStorageService ) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    datosVehiculo(vehiculo:VehiculoEntity): Observable<DetalleVehiculoEntity> {
        let body = JSON.stringify(vehiculo);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarVehiculoRenovacion", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    insertarVehiculoRenovacion(detalleVehiculo): Observable<boolean> {
        let body = JSON.stringify(detalleVehiculo);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/insertarVehiculoRenovacion", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    datosOtrosRamos(otrosRamos:ProductosGeneralesEntity): Observable<DetallesProductosGenerales> {
        let body = JSON.stringify(otrosRamos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarProductoGeneral", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    insertarOtroRamoRenovacion(detalleOtroRamo): Observable<boolean> {
        let body = JSON.stringify(detalleOtroRamo);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/insertarProductoGeneralRenovacion", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    datosAsistenciaMedica(asistencia:AsistenciaMedicaEntity): Observable<DetalleAsistenciaMedica> {
        let body = JSON.stringify(asistencia);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarAsistenciaMedica", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    insertarAsistenciaMedicaRenovacion(detalleAsistenciaMedica): Observable<boolean> {
        let body = JSON.stringify(detalleAsistenciaMedica);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/insertarAsistenciaMedica", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    datosVivienda(viviendaSelect:ViviendaEntity): Observable<DetalleViviendaEntity> {
        let body = JSON.stringify(viviendaSelect);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultarVivienda", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    insertarViviendaRenovacion(detalleVivienda): Observable<boolean> {
        let body = JSON.stringify(detalleVivienda);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/insertarVivienda", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/renovaciones/renovacion.service.ts